import { render, staticRenderFns } from "./listMentor.vue?vue&type=template&id=5e56b1f5&"
import script from "./listMentor.vue?vue&type=script&lang=js&"
export * from "./listMentor.vue?vue&type=script&lang=js&"
import style0 from "./listMentor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports